import apiClient from './client';
import { API_PATHS } from './paths';
import type { ApiResponse } from '../types/api';
import type { ClientService } from '../types/client';

export const clientServicesApi = {
  getList: async (providerId?: number): Promise<ClientService[]> => {
    const res = await apiClient.get<ApiResponse<ClientService[]>>(API_PATHS.CLIENT_SERVICES, {
      params: providerId !== undefined ? { providerId } : undefined,
    });
    return res.data.data;
  },
};
